import { ThemedText } from "@/components/ThemedText";
import { useLocalSearchParams, useSegments } from "expo-router";
import { View } from "react-native";

export default function OverviewIndex() {
  const segs = useSegments();
  const page = segs[2];
  const { entity } = useLocalSearchParams();
  return (
    <View>
      <ThemedText>{page}</ThemedText>
      <ThemedText>{entity}</ThemedText>
    </View>
  );
}
